import { render, staticRenderFns } from "./SIdentity.vue?vue&type=template&id=4e7fba5a&scoped=true"
import script from "./SIdentity.vue?vue&type=script&lang=js"
export * from "./SIdentity.vue?vue&type=script&lang=js"
import style0 from "./SIdentity.vue?vue&type=style&index=0&id=4e7fba5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7fba5a",
  null
  
)

export default component.exports